import * as Sentry from '@sentry/browser';

function initSentry() {
  if (process.env.ENVIRONMENT && ['development', 'production'].includes(process.env.ENVIRONMENT)) {
    Sentry.init({
      dsn: `https://c028663a89a14fe3eef7a9637b1c1480@o4508172385976320.ingest.de.sentry.io/4508212869988432`,
      release: process.env.RELEASE,
      environment: process.env.ENVIRONMENT
    });
  }
}

function setUserScope(user: User) {
  Sentry.configureScope(scope => {
    scope.setUser({
      id: `${user.id}`,
      email: user.email,
      username: user.name
    });
  });
}

export { initSentry, setUserScope };
